import Lottie from 'lottie-react';
import { headers } from '../layout/header/Header';
import { Lotties } from '@lemon/assets';

export const Epyt = () => {
    return (
        <div
            id={headers[0].id}
            className="w-full h-full flex flex-col items-center justify-center bg-primary-black pt-[100px]"
        >
            <div className="pt-20 md:pt-32" />
            <div className="w-full max-w-[1200px] mx-auto h-full flex flex-col items-center justify-center px-4">
                <Lottie animationData={Lotties.epyt} loop={true} className="w-[237px] md:w-full md:max-w-[950px]" />

                <div className="pt-12 md:pt-24 text-[24px] md:text-[32px] lg:text-[40px] font-bold text-white text-center px-4 text-balance">
                    비쥬얼 데이터 기반
                    <br className="md:hidden" />
                    <span className="hidden md:inline"> </span>
                    초개인화 뷰티 큐레이션
                </div>

                <div className="w-full h-10" />

                <div className="text-[16px] md:text-[20px] lg:text-2xl text-white/60 text-center px-4 break-keep text-pretty leading-6">
                    고객 개인의 얼굴, 눈매, 체형, 피부 톤 등
                    <br className="md:hidden" />
                    <span className="hidden md:inline"> </span>
                    비주얼 특성을 AI가 파악해
                </div>

                <div className="w-full h-[8px] md:h-[12px]" />

                <div className="text-[16px] md:text-[20px] lg:text-2xl text-white/60 text-center px-4 break-keep text-pretty leading-6">
                    '나에게 딱 맞는' 뷰티 콘텐츠와 제품을 실시간으로 큐레이션합니다.
                </div>
            </div>
        </div>
    );
};
